import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link} from 'react-router-dom';
import { useState } from 'react';
import '../../Styles/Header/Header.scss'
import MyButton from '../../UI/button/MyButton';
import BurgerMenu from './BurgerMenu';
import logo from './Icon/main_icon.svg';
import MenuLarge from './MenuLarge';
import MenuMedium from './MenuMedium';
import MenuMobile from './MenuMobile';
import ModalMenu from './ModalMenu';
import Profile from './Profile';
import Time from './Time';
import Application from '../Main/Application';
import BlockSubstrate from '../../UI/blocksubstrate/BlockSubstrate';
import { useEffect } from 'react';
import { useRef } from 'react';


function Header() {

   useEffect(() => {
      window.addEventListener('click', (e) => {
         if (e.target.closest('#burgerMenu') !== menuBurger.current) {
            setMenuActive(false)
         }
         if (e.target.classList.contains('header__popUp-Aplication-active')) {
            setIsActivePopUpApplication(false);
         }
      })
   })

   const [menuActive, setMenuActive] = useState(false);
   const [heightHeader, setHeightHeader] = useState(80);
   const [isActivePopUpApplication, setIsActivePopUpApplication] = useState(false);

   const menuBurger = useRef()

   // const activateMenu = (e) => {
   //    let button = document.querySelector('.burger__body');
   //    setHeightHeader(button.clientHeight);
   // }

   const popUpContact = () => {
      isActivePopUpApplication ? setIsActivePopUpApplication(false) : setIsActivePopUpApplication(true);
   }

   return (
      <div className='header__wrapper'>
         <div className='header__container container'>
            <div className="header__body">
               <div className="header__logo">
                  <Link to='/'><img src={ logo } alt="BikePark" /></Link>
               </div>
               <div className="header__menu-large">
                  <MenuLarge/>
               </div>
               <div className="header__menu-medium">
                  <MenuMedium/>
               </div>
               <div className="header__phone color-text">+654 21 547 4587</div>
               <div className="header__profile">
                  <Profile/>
               </div>
               <div className="header__feedbak">
                  <MyButton
                     style={{ fontSize: '14px', fontWeight: 500 }}
                     onClick={popUpContact}
                  >
                     Contact Us
                  </MyButton>
               </div>
               <div className="header__time-info">
                  <Time/>
               </div>
               <div className="header__burger-menu">
                  <BurgerMenu
                     menuBurger={menuBurger}
                     menuActive={menuActive}
                     setMenuActive={setMenuActive}
                     />
               </div>
               <div className={menuActive ? "header__modal-menu-active" : "header__modal-menu"} >
                  <ModalMenu heightHeader={heightHeader}>
                     <MenuLarge/>
                  </ModalMenu>
               </div>
               <div className={menuActive ? "header__modal-mobile-menu-active" : "header__modal-mobile-menu"} >
                  <ModalMenu heightHeader={heightHeader} >
                     <MenuMobile/>
                  </ModalMenu>
               </div>
               <div className={ isActivePopUpApplication ? "header__popUp-Aplication-active" : "header__popUp-Aplication"}>
                  <div className="header__popUp-body">
                     <BlockSubstrate>
                        <div className="header__popUp-content">
                           <Application
                              setIsActivePopUpApplication={setIsActivePopUpApplication}
                           />
                        </div>
                     </BlockSubstrate>
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
}
export default Header;